export default __webpack_public_path__ + "static/media/arbitrium.36e10df4.svg";